
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/DataGrid",
      function () {
        return require("private-next-pages/components/DataGrid/index.mdx");
      }
    ]);
  